import React, { useMemo } from "react";
import { useGetHtmlApiQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { getDateUpdate } from "../Utils/utils";
import PageLastUpdated from "../components/shared/PageLastUpdated";
import { useLocation } from "react-router-dom";
import useSeo from "../hooks/useSeo";

const PerformanceHighlights = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  const {
    data: performanceHighlightHtml = {},
    isLoading: performanceHighlightIsLoading,
  } = useGetHtmlApiQuery({ url: 1198, lang: languageType });

  const pageBody =
    performanceHighlightHtml?.body?.[0]?.value ?? "No content available";
  const pageTitle =
    performanceHighlightHtml?.title?.[0]?.value ?? "No content available";

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(performanceHighlightHtml?.changed?.[0]?.value);
  }, [performanceHighlightHtml]);

  if (performanceHighlightIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/about-us/corporate-governance"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div dangerouslySetInnerHTML={{ __html: pageBody }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PerformanceHighlights;
